import React, { Component } from 'react';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';
import { Typography } from 'rmwc/Typography';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryText,
  ListItemGraphic,
  ListItemMeta
} from 'rmwc/List';
import { Card } from 'rmwc/Card';

import { Link } from 'react-router-dom'
import ReactGA from 'react-ga';

class MyRegistration extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      open: false,
      questionOpen: false,
      initialApiLoading: false,
      data:{
        'payments': []
      },
      regDetails:{
        'level': '',
        'tracks': [],
        'topics': [],
        'time_slot': [],
        'test_city': '',
        'test': 'tests'
      },
      sampleQuestions:{
        'trackQuestions': [],
        'errorMessage':'',
        'questionStatus':''
      },
      tpoRegStatus:{
        'regStatus':'',
        'certPartId':'',
        'certificateType': '',
      },
    };
    this.handlePay = this.handlePay.bind(this)
    this.handleInvoice = this.handleInvoice.bind(this)
  }

  componentDidMount() {
    ReactGA.set({ userId: this.props.user.id });
    ReactGA.initialize('UA-139837993-1');
    ReactGA.pageview('/my_registration');
    
    let data = Object.assign({}, this.state.data)
    let tpoRegStatus = Object.assign({}, this.state.tpoRegStatus)
    let payments
    return api.getPayments(this.props.user.accessToken)
      .then((result) => {
        //console.log(result)
        data.payments = result.payments
        return api.getResponse(this.props.user.accessToken, 'partial/reg/fetch/user/4')
    }).then((result) => {
        if(result.status === 'success'){
          tpoRegStatus.regStatus = 'partial_tq'
          tpoRegStatus.certPartId = result.data.id
          tpoRegStatus.certificateType = result.type
        }
        this.setState({data: data, initialApiLoading:true, tpoRegStatus: tpoRegStatus})
    })
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };


  handlePay = (e, data) => {
    e.preventDefault();
    api.proceedPayment(this.props.user.accessToken, data.id)
    .then((result) => {
      window.location.href = result.redirect_to;
    })
  }

    handleInvoice = (e, paymentId) => {

    e.preventDefault()
    let payId = paymentId + ".pdf" 

    api.downloadTPOInvoice(this.props.user.accessToken, payId)
      .then((result) => {
        if (result instanceof Blob) {
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'invoice.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({errorMsg: 'Unable to download invoice. Please contact Administrator' })
          
        }  
    })

  }

   handleShowDetails = (e, data) => {
    e.preventDefault();
    let regDetails = Object.assign({}, this.state.regDetails)
    this.setState({open: true, questionOpen:false})
    api.fetchRegDetails(this.props.user.accessToken, data.certification_participation_id)
    .then((result) => {
      regDetails = result.data
      this.setState({open: true, regDetails: regDetails})
    })
  }

  handleQuestionsDownload = (e, data) => {
    e.preventDefault();
    this.setState({questionOpen: true,  open:false})
    let sampleQuestions = Object.assign({}, this.state.sampleQuestions)
    api.fetchTPOSampleQuestions(this.props.user.accessToken, data.certification_participation_id)
    .then((result) => {
      if(result.status === 'success'){
        sampleQuestions.questionStatus = result.status
        sampleQuestions.trackQuestions = result.data
      }
      else{
        sampleQuestions.questionStatus = result.status
        sampleQuestions.errorMessage = result.data
      }

      this.setState({questionOpen: true, sampleQuestions: sampleQuestions})
    })
  }

  handleUpdateTPO = (e, data) => {
    e.preventDefault();
    let cert_part_id = data.certification_participation_id
    this.props.history.push(`/portal/app/tpo_registration_update/${cert_part_id}`)

  }

  handleUpdateTQ = (e, data) => {
    e.preventDefault();
    let cert_part_id = data.certification_participation_id
    this.props.history.push(`/portal/app/fetch/tq/registration/${cert_part_id}`)
  }

  handlePartialTQ = (e, regStatus) => {
    e.preventDefault();
    let certPartId = regStatus.certPartId
    let certType = regStatus.certificateType
    this.props.history.push(`/portal/app/tq_registration/${certType}/partial/${certPartId}`)
  }

  render() {
    //console.log('******************')
    //console.log(this.props.user.id)
    //console.log('******************')
    let handlePay = this.handlePay
    let handleShowDetails = this.handleShowDetails
    let handleInvoice = this.handleInvoice
    let tableBody
    let accessToken = this.props.user.accessToken
    let noRegistrationContent
    let questionDownloadLink
    let tpoUpdateOption
    let handleQuestionsDownload = this.handleQuestionsDownload
    let handleUpdateTPO = this.handleUpdateTPO
    let handleUpdateTQ = this.handleUpdateTQ
    let mcentaMessage
    let tpoStatusComponent
    if(this.state.tpoRegStatus.regStatus === 'partial_tq'){
      tpoStatusComponent = (
        <Card>
          <Grid>
            <GridCell span="10">
                You have already started the registration process. Please click on the Update button to update your details and complete your registration.
            </GridCell>
            <GridCell span="2">
              <Button raised dense onClick={((e) => {this.handlePartialTQ(e, this.state.tpoRegStatus)})} size="sm">Update</Button>
            </GridCell>
          </Grid>
        </Card>
        )
    }

    if(this.state.data.payments.length>0){
    tableBody = <div><table className="myRegistrationTable">
        <th className="myRegistrationDateField">Date</th>
        <th className="myRegistrationTypeField">Registration Type</th>
        <th>Sample Questions</th>
        <th>Mode of payment</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Payment / Invoice</th>
        <th>Update</th>
        <tbody>

        {this.state.data.payments.map(function(payment) {
          payment.created_at = payment.created_at.split('T')[0]
          if(payment.certification_type_name =='FC')
            payment.certification_type_name = 'CENTA Certification'
          else if(payment.certification_type_name =='MC')
            payment.certification_type_name = 'Micro-Credentials'
          else if(payment.certification_type_name =='TQ')
            payment.certification_type_name = 'TQ (first stage of TPO)'
                      
          if (payment.certification_type_name === 'TPO'){
            questionDownloadLink = <Button dense onClick={((e) => handleQuestionsDownload(e, payment))}>download</Button>
          }
          else{
            questionDownloadLink = 'N/A' 
          }

          if (payment.certification_type_name === 'TPO' && !(payment.status == "Credit" || payment.status == "In Process")){
            tpoUpdateOption = <div hidden> <Button dense onClick={((e) => handleUpdateTPO(e, payment))}>Update</Button> </div>
          }
          else if(payment.certification_type_name === 'TQ (first stage of TPO)' && !(payment.status == "Credit" || payment.status == "In Process")){
             tpoUpdateOption = <div> <Button dense onClick={((e) => handleUpdateTQ(e, payment))}>Update</Button> </div>
          }

          else{
            tpoUpdateOption = 'N/A' 
          }

          if(payment.payment_mode_name === 'Wallets (Ola Money/Mobikwik/Freecharge/Jio Money)')
            payment.payment_mode_name ='Mobile Wallets'

          else if(payment.payment_mode_name === 'UPI (BHIM/Paytm/PhonePe/Tez)')
            payment.payment_mode_name ='UPI'

          else if(payment.payment_mode_name === 'Credit Card/Debit Card/Netbanking')
            payment.payment_mode_name ='Credit/Debit/Netbanking'

          if(payment.status === "In Process"){
            return (
              <tr>
                <td>{payment.created_at}</td>
                <td><Button dense onClick={((e) => handleShowDetails(e, payment))}>{payment.certification_type_name}</Button></td>
                <td>N/A</td>
                <td>{payment.payment_mode_name}</td>
                <td>{payment.amount}</td>
                <td>{payment.status}</td>
                <td>Payment in process. Refresh to view updated status</td>
                <td>{tpoUpdateOption}</td>
              </tr>
            )
          }
          else if(payment.status !== "Credit" && payment.currency==="RS"){
            if (payment.amount === '0.0') {
              return (
                <tr>
                  <td>{payment.created_at}</td>
                  <td><Button dense onClick={((e) => handleShowDetails(e, payment))}>{payment.certification_type_name}</Button></td>
                  <td>N/A</td>
                  <td>{payment.payment_mode_name}</td>
                  <td>{payment.amount}</td>
                  <td>Scholarship</td>
                  <td>-</td>
                  <td>{tpoUpdateOption}</td>
                </tr>
              )
            }
            else {
              /** disable payment option for tpo. enable when the form is re opened again*/
              let paymentButton
              if(payment.payment_eligibility === "yes"){
                paymentButton = (<Button onClick={((e) => handlePay(e, payment))}>Pay</Button>)
              }
              else{
                paymentButton = 'N/A'
              }
              return (
                <tr>
                  <td>{payment.created_at}</td>
                  <td><Button dense onClick={((e) => handleShowDetails(e, payment))}>{payment.certification_type_name}</Button></td>
                  <td>N/A</td>
                  <td>{payment.payment_mode_name}</td>
                  <td>{payment.amount}</td>
                  <td>{payment.status}</td>
                  <td>{paymentButton}</td>
                  <td>{tpoUpdateOption}</td>
                </tr>
              )
            }
          }
          else if(payment.status != "Credit" && payment.currency!=="RS"){
            return (
              <tr>
                <td>{payment.created_at}</td>
                <td><Button dense onClick={((e) => handleShowDetails(e, payment))}>{payment.certification_type_name}</Button></td>
                <td>N/A</td>
                <td>{payment.payment_mode_name}</td>
                <td>{payment.amount}</td>
                <td>{payment.status}</td>
                <td></td>
                <td>{tpoUpdateOption}</td>
              </tr>
            )
          }
          
          let invoiceLink = '/api/invoice/'+accessToken+'/'+payment.id+'.pdf'
          return (
            <tr>
              <td>{payment.created_at}</td>
              <td><Button dense onClick={((e) => handleShowDetails(e, payment))}>{payment.certification_type_name}</Button></td>
              <td>{questionDownloadLink}</td>
              <td>{payment.payment_mode_name}</td>
              <td>{payment.amount}</td>
              <td>{payment.status}</td>
              <td><a href='' onClick={((e) => handleInvoice(e, payment.id))} target="_blank">Invoice</a></td>
              <td>{tpoUpdateOption}</td>

            </tr>
          )
        })}
      
      </tbody>
      </table>
      <br/>
      <Typography use="subtitle2"><b>Note:</b> Kindly note that if the chosen exam date has already passed, the payment button will be disabled. Please use the update button to change your preferred date and complete your registration.</Typography>
      <br/>
      <br/>
      <Typography use="subtitle" style={{color:'blue'}}> Please click on Teaching Quotient in the above table (under Registration Type) to see your invite code and test link.</Typography>

      </div>

      mcentaMessage = (<Grid> <GridCell span="12">
        <Typography use="subtitle2">Please download the MyCENTA app (<a href="https://m.centa.org" target="_blank">m.centa.org</a>)! You can access a set of curated learning resources and sample quizzes through MyCENTA. Open <a href="https://m.centa.org" target="_blank">m.centa.org</a> in your mobile browser, add the app to your homescreen and sign in!</Typography>
        <br/>
        </GridCell> </Grid>
        )
    }
    else{
      if(this.state.initialApiLoading){
        if(this.state.tpoRegStatus.regStatus !== 'incomplete_reg'){
        noRegistrationContent = ( <div><br/> 
                      <Typography use="subtitle2">You do not have any live registrations. </Typography>
                      
                      <Typography use="subtitle2">Click on the links below to register for</Typography>

                      <List>
                       <br/> 
                       <ListItem>
                          <ListItemGraphic>star_border</ListItemGraphic>
                          <ListItemText><Link to="/portal/app/tq_registration/TPO/new/0">CENTA Teaching Professionals' Olympiad (TPO) 2020</Link> <br /><Typography use="caption">India's national competition for teachers</Typography></ListItemText>
                          
                        </ListItem> 
                       <br/>
                       <ListItem>
                          <ListItemGraphic>star_border</ListItemGraphic>
                          <ListItemText><Link to="/portal/app/tq_registration/TQ/new/0">CENTA Teaching Quotient (TQ)</Link><br /><Typography use="caption">Competency score for teacher recruitment</Typography></ListItemText>
                        </ListItem>
                       <br/>
                       <ListItem>
                          <ListItemGraphic>star_border</ListItemGraphic>
                          <ListItemText><Link to="/portal/app/mc_registration">CENTA Micro-Credentials</Link><br /><Typography use="caption">Certifications of excellence in teaching - focused on specific sets of competencies</Typography></ListItemText>
                          
                        </ListItem>
                        <br/>
                        <ListItem>
                          <ListItemGraphic>star_border</ListItemGraphic>
                          <ListItemText><Link to="/portal/app/fc_registration">CENTA Certification</Link><br /><Typography use="caption">Certification of excellence in teaching - combining all Micro-Credentials</Typography></ListItemText>
                        </ListItem>
                        

                      </List>
                    </div>
                  )
        }
        else{
          noRegistrationContent = (<div> </div>)
        }

      }
      else{
        noRegistrationContent = (
          <div className="loader-component">
            <div className="loader"></div>
            <h4> Loading. Please wait..</h4>
          </div>
        )
      }
    }
    const { open } = this.state;
    const { questionOpen } = this.state;
    let regDetails = this.state.regDetails;
    let trackComponent
    let topicComponent
    let timeSlotComponent
    let testDateComponent

    if(regDetails.tracks!== undefined && regDetails.tracks.length >0){
     trackComponent = (<div><h4 className="myRegistrationHeading"> Tracks: </h4>
            {this.state.regDetails.tracks.map(regDetail => (
              <div> <Typography use="subtitle2">{regDetail}</Typography></div>
            ))}

            </div>)
    }

    if(regDetails.topics!== undefined && regDetails.topics.length >0){
     topicComponent = (<div><h5 className="myRegistrationHeading"> Micro Credentails: </h5>
            {this.state.regDetails.topics.map(regDetail => (
              <div> <Typography use="subtitle2">{regDetail}</Typography></div>
            ))}

            </div>)
    }

    if(regDetails.time_slot!== undefined && regDetails.time_slot.length >0){
     timeSlotComponent = (<div><h5> Time Slots: </h5>
            {this.state.regDetails.time_slot.map(regDetail => (
              <p> {regDetail} </p>
            ))}

            </div>)
    }

    let testCityComponent

    if(regDetails.test_city!== undefined)
      testCityComponent = (<p> Test Center: {regDetails.test_city} </p>)

    if(regDetails.test_date!== undefined)
      testDateComponent = (<p> Test Date: {regDetails.test_date} </p>)

    let mcTestDateComponent
    if(regDetails.mc_test_dates!== undefined && regDetails.mc_test_dates.length >0){
     mcTestDateComponent = (<div><h5 className="myRegistrationHeading"> Test Dates: </h5>
            {this.state.regDetails.mc_test_dates.map(mcTestDate => (
              <div><Typography use="subtitle2"> {mcTestDate.name} on {mcTestDate.date} at {mcTestDate.time} </Typography></div>
            ))}

            </div>)
    }

    let fcTestDateComponent
    let count = 0
    if(regDetails.fc_test_dates!== undefined && regDetails.fc_test_dates.length >0){
     fcTestDateComponent = (<div><h5 className="myRegistrationHeading"> Test Dates: </h5>
            {this.state.regDetails.fc_test_dates.map(fcTestDate => (
              <div><Typography use="subtitle2"> Test {++count} on {fcTestDate.date} at {fcTestDate.time} </Typography></div>
            ))}

            </div>)
    }

    let tqTypenameComponent;
     if(regDetails.global_type_name !== undefined){
      tqTypenameComponent = (<p>TQ Type: {regDetails.global_type_name}</p>)
     }

     let tqExamDateComponent
     if(regDetails.selected_exam_date !== undefined){
      tqExamDateComponent = (<p><b>Exam Date:</b> {regDetails.selected_exam_date}</p>)
     }


    let tqTimeSlotComponent;
    if(regDetails.selected_time_slot){
      tqTimeSlotComponent = (
        <p>
          <b>Time Slot:</b> {regDetails.selected_time_slot}
        </p>
        )
    }


     let couponCodeComponent
     if(regDetails.coupon_code_id !== undefined){
      couponCodeComponent = (<p>Invite Code (To be entered on the Test Link): {regDetails.coupon_code_id}</p>)
     }

     let examLinkComponentComponent
     if(regDetails.exam_link !== undefined){
      examLinkComponentComponent = (<div>Test Link: <a href={this.state.regDetails.exam_link} target="_blank"> {this.state.regDetails.exam_link} </a></div>)
     }
     let addOnComponent
     if(regDetails.add_on_option_message){
        addOnComponent = (<div><Typography use= "subtitle2"><b>Note:</b> {this.state.regDetails.add_on_option_message}</Typography></div>)
      }


    let regDetailsModal=(
      <Dialog
        open={open}
         onClose={evt => this.setState({standardDialogOpen: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Registration Details</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          {testCityComponent}
          {testDateComponent}
          {tqExamDateComponent}
          {tqTimeSlotComponent}
          {regDetails.level}
          {trackComponent}
          {topicComponent}
          {timeSlotComponent}
          {mcTestDateComponent}
          {fcTestDateComponent}
          {addOnComponent}


        </DialogBody>
        <DialogFooter>
            <DialogFooterButton cancel>Close</DialogFooterButton>
            
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )


    let questionsModalBody
    
    if(this.state.sampleQuestions.questionStatus === 'success'){
      questionsModalBody= <DialogBody>
        {this.state.sampleQuestions.trackQuestions.map(questions => (
          <p> <a href={questions.link} target="_blank">{questions.name} </a> </p>
        ))}
        </DialogBody>
    }
    else if(this.state.sampleQuestions.questionStatus === 'error'){
      questionsModalBody= <DialogBody>
          <p> {this.state.sampleQuestions.errorMessage} </p>
      </DialogBody> 
    }

    
    let questionDownloadModal=(
      <Dialog
        open={questionOpen}
         onClose={evt => this.setState({standardDialogOpen: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Sample Questions Download - Click on link to download</DialogHeaderTitle>
        </DialogHeader>
        {questionsModalBody}
        <DialogFooter>
            <DialogFooterButton cancel>Close</DialogFooterButton>
            
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )

    // let tpoStatusComponent

    

    // if(this.state.tpoRegStatus.regStatus === 'incomplete_reg'){
    //    tpoStatusComponent = (<Grid> <GridCell span="12">
    //      <Typography use="heading5">TPO Registration is Incomplete. Please update the details to complete the registration</Typography>
    //      <div hidden> <Button dense onClick={((e) => handleUpdateTPO(e, this.state.tpoRegStatus.certPartId))}>Update</Button> </div>
        
    //      </GridCell> </Grid>
    //      )
    //  }


    return (
      <div class="mdc-layout-grid">
        
        <div class="mdc-layout-grid__inner"> 
          <div class="mdc-layout-grid__cell--span-10">
            <Typography use="headline5">My Registration Activities</Typography>

            <div>
              <br/>
              {mcentaMessage}

              {tpoStatusComponent}

              <br/>
              
              {tableBody}
              <br/>
                          
              {noRegistrationContent}  
            </div>
            
            {regDetailsModal}
            {questionDownloadModal}
          <div class="mdc-layout-grid__cell--span-1"></div>
          
          <br/>
          <br/>
          Your Username is  <u><b>{this.props.user.userName}</b></u>. Please make a note of this.
          <div class="mdc-layout-grid__cell--span-1"></div>
        </div>
      </div>
      
    </div>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyRegistration);


// WEBPACK FOOTER //
// ./src/views/MyRegistration.jsx